import React from 'react';

import { bool, func, string } from 'prop-types';

import { classNames } from '@philips-emr/tws-utils';

import './collapse-arrow.scss';

function CollapseArrow({ collapsed, onClick, className }) {
  const classes = {
    'c-collapse-arrow': true,
    'collapsed': collapsed,
    [className]: Boolean(className),
  };

  return <div className={classNames(classes)} data-testid="collapse-arrow" onClick={onClick} />;
}

CollapseArrow.propTypes = {
  className: string,
  collapsed: bool,
  onClick: func,
};

export default CollapseArrow;
